/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

var currentSummaryIndex = 0;
// Summary indexes
// Monitor
var retryPageIndex = 0;
var diagnosticPageIndex = 0;
var faultPageIndex = 0;
var errorConfigPageIndex = 0;
var errorParamPageIndex = 0;
var missingPageIndex = 0;
var onlinePageIndex = 0;
var automaticBlacklistPageIndex = 0;
var masterFaultPageIndex = 0;
var fiberLowerLimitMaintenanceRequiredPageIndex = 0;
var fiberLowerLimitUrgentMaintenancePageIndex = 0;
var fiberSignalLostPageIndex = 0;
// Scope DP
var terminationOFFPageIndex = 0;
var noPowerSupplyTerminationPageIndex = 0;
var highResistancePageIndex = 0;
var aNotOkPageIndex = 0;
var bNotOkPageIndex = 0;
var longCablePageIndex = 0;
var noisePageIndex = 0;
var reflectionPageIndex = 0;
// Disclaimer
var disclaimerPageIndex = 0;

const baudRateValues = [
  { "baudRate": "9.6 kbit/s", "cableLength": "1000 m" },
  { "baudRate": "19.2 kbit/s", "cableLength": "1000 m" },
  { "baudRate": "45.45 kbit/s", "cableLength": "1000 m" },
  { "baudRate": "93.75 kbit/s", "cableLength": "1000 m" },
  { "baudRate": "187.5 kbit/s", "cableLength": "1000 m" },
  { "baudRate": "500.0 kbit/s", "cableLength": "400 m" },
  { "baudRate": "1.5 Mbit/s", "cableLength": "200 m" },
  { "baudRate": "3.0 Mbit/s", "cableLength": "100 m" },
  { "baudRate": "6.0 Mbit/s", "cableLength": "100 m" },
  { "baudRate": "12.0 Mbit/s", "cableLength": "100 m" }
];

export class TsExpertReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      // Protocol
      firstRetryPage: -1,
      firstDiagnosticPage: -1,
      firstFaultPage: -1,
      firstErrorConfigPage: -1,
      firstErrorParamPage: -1,
      firstMissingPage: -1,
      firstOnlinePage: -1,
      firstAutomaticBlacklistPage: -1,
      firstMasterFaultPage: -1,
      firstFiberLowerLimitMaintenanceRequiredPage: -1,
      firstFiberLowerLimitUrgentMaintenancePage: -1,
      firstFiberSignalLostPage: -1,
      // Scope DP
      firstTerminationOFFPage: -1,
      firstNoPowerSupplyTerminationPage: -1,
      firstHighResistancePage: -1,
      firstANotOkPage: -1,
      firstBNotOkPage: -1,
      firstLongCablePage: -1,
      firstNoisePage: -1,
      firstReflectionPage: -1,
      // Summary numbering control
      // Protocol
      isFirstRetryPage: true,
      isFirstDiagnosticPage: true,
      isFirstFaultPage: true,
      isFirstErrorConfigPage: true,
      isFirstErrorParamPage: true,
      isFirstMissingPage: true,
      isFirstOnlinePage: true,
      isFirstAutomaticBlacklistPage: true,
      isFirstMasterFaultPage: true,
      isFirstFiberLowerLimitMaintenanceRequiredPage: true,
      isFirstFiberLowerLimitUrgentMaintenancePage: true,
      isFirstFiberSignalLostPage: true,
      // Scope DP
      isFirstTerminationOFFPage: true,
      isFirstNoPowerSupplyTerminationPage: true,
      isFirstHighResistancePage: true,
      isFirstANotOkPage: true,
      isFirstBNotOkPage: true,
      isFirstLongCablePage: true,
      isFirstNoisePage: true,
      isFirstReflectionPage: true,
      // The report itself
      doc: ""
    };

  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  formatTime = (problem) => {
    if (problem.ntp !== null && problem.ntp === true) {
      let parsedMillis = Date.parse(problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problem.time !== undefined && problem.time !== null) {
      const eventTimeInMillis = problem.time * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  formatTime2 = (problemTime, ntp) => {
    if (ntp !== null && ntp === true) {
      let parsedMillis = Date.parse(problemTime);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problemTime !== undefined && problemTime !== null) {
      const eventTimeInMillis = problemTime * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  /*
    The measurement time that is retrieved from the database comes as a string.
    We had a problem that the time that was being retrieved was not correct. 
    The workarround we found for this was to remove the last two characters of 
    the string and it miraculously it was in the format we nedded 
  */
  formatUptimeStringToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      let uptimeSubstring = uptimeInSeconds.substring(0, uptimeInSeconds.length - 2);
      let uptimeSubstringNumber = parseInt(uptimeSubstring);
      const uptimeInMillis = uptimeSubstringNumber * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  getDateTimeSince = (target) => {
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  parseFloatTo2DecimalPlaces = (floatInput) => {
    // If the floatInput is not 'None' return the number trimmed to 2 decimal places
    if (floatInput !== Constants.NONE) {
      return parseFloat(floatInput).toFixed(2);
    }
    else {
      return floatInput;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.TS_EXPERT_REPORT_EXPORT_NAME}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, ${Strings.PAGE} ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "retry" && this.state.isFirstRetryPage) {
      this.setState({
        firstRetryPage: pageNumber + 1,
        isFirstRetryPage: false
      });
    }
    else if (reportPart === "diagnostic" && this.state.isFirstDiagnosticPage) {
      this.setState({
        firstDiagnosticPage: pageNumber + 1,
        isFirstDiagnosticPage: false
      });
    }
    else if (reportPart === "fault" && this.state.isFirstFaultPage) {
      this.setState({
        firstFaultPage: pageNumber + 1,
        isFirstFaultPage: false
      });
    }
    else if (reportPart === "errorConfig" && this.state.isFirstErrorConfigPage) {
      this.setState({
        firstErrorConfigPage: pageNumber + 1,
        isFirstErrorConfigPage: false
      });
    }
    else if (reportPart === "errorParam" && this.state.isFirstErrorParamPage) {
      this.setState({
        firstErrorParamPage: pageNumber + 1,
        isFirstErrorParamPage: false
      });
    }
    else if (reportPart === "missing" && this.state.isFirstMissingPage) {
      this.setState({
        firstMissingPage: pageNumber + 1,
        isFirstMissingPage: false
      });
    }
    else if (reportPart === "online" && this.state.isFirstOnlinePage) {
      this.setState({
        firstOnlinePage: pageNumber + 1,
        isFirstOnlinePage: false
      });
    }
    else if (reportPart === "automaticBlacklist" && this.state.isFirstAutomaticBlacklistPage) {
      this.setState({
        firstAutomaticBlacklistPage: pageNumber + 1,
        isFirstAutomaticBlacklistPage: false
      });
    }
    else if (reportPart === "masterFault" && this.state.isFirstMasterFaultPage) {
      this.setState({
        firstMasterFaultPage: pageNumber + 1,
        isFirstMasterFaultPage: false
      });
    }
    else if (reportPart === "fiberLowerLimitMaintenanceRequired" && this.state.isFirstFiberLowerLimitMaintenanceRequiredPage) {
      this.setState({
        firstFiberLowerLimitMaintenanceRequiredPage: pageNumber + 1,
        isFirstFiberLowerLimitMaintenanceRequiredPage: false
      });
    }
    else if (reportPart === "fiberLowerLimitUrgentMaintenance" && this.state.isFirstFiberLowerLimitUrgentMaintenancePage) {
      this.setState({
        firstFiberLowerLimitUrgentMaintenancePage: pageNumber + 1,
        isFirstFiberLowerLimitUrgentMaintenancePage: false
      });
    }
    else if (reportPart === "fiberSignalLost" && this.state.isFirstFiberSignalLostPage) {
      this.setState({
        firstFiberSignalLostPage: pageNumber + 1,
        isFirstFiberSignalLostPage: false
      });
    }
    else if (reportPart === "terminationOFF" && this.state.isFirstTerminationOFFPage) {
      this.setState({
        firstTerminationOFFPage: pageNumber + 1,
        isFirstTerminationOFFPage: false
      });
    }
    else if (reportPart === "noPowerSupplyTermination" && this.state.isFirstNoPowerSupplyTerminationPage) {
      this.setState({
        firstNoPowerSupplyTerminationPage: pageNumber + 1,
        isFirstNoPowerSupplyTerminationPage: false
      });
    }
    else if (reportPart === "highResistance" && this.state.isFirstHighResistancePage) {
      this.setState({
        firstHighResistancePage: pageNumber + 1,
        isFirstHighResistancePage: false
      });
    }
    else if (reportPart === "aNotOk" && this.state.isFirstANotOkPage) {
      this.setState({
        firstANotOkPage: pageNumber + 1,
        isFirstANotOkPage: false
      });
    }
    else if (reportPart === "bNotOk" && this.state.isFirstBNotOkPage) {
      this.setState({
        firstBNotOkPage: pageNumber + 1,
        isFirstBNotOkPage: false
      });
    }
    else if (reportPart === "longCable" && this.state.isFirstLongCablePage) {
      this.setState({
        firstLongCablePage: pageNumber + 1,
        isFirstLongCablePage: false
      });
    }
    else if (reportPart === "noise" && this.state.isFirstNoisePage) {
      this.setState({
        firstNoisePage: pageNumber + 1,
        isFirstNoisePage: false
      });
    }
    else if (reportPart === "reflection" && this.state.isFirstReflectionPage) {
      this.setState({
        firstReflectionPage: pageNumber + 1,
        isFirstReflectionPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.TS_EXPERT_REPORT_EXPORT_NAME}>
      {this.createIntroPage()}
      {this.createDataInfoPage()}
      {this.createSummaryPage()}
      {/* Protocol */}
      {this.createRetriesPages()}
      {this.createDiagnosticsPages()}
      {this.createFaultsPages()}
      {this.createConfigErrorPages()}
      {this.createParamErrorPages()}
      {this.createMissingPages()}
      {this.createOnlinePages()}
      {this.createCriticalSlavePages()}
      {this.createMasterFaultPages()}
      {this.createFiberLowerLimitMaintenanceRequiredPages()}
      {this.createFiberLowerLimitUrgentMaintenancePages()}
      {this.createFiberSignalLostPages()}
      {/* Scope DP */}
      {this.createTerminationOFFPages()}
      {this.createNoPowerSupplyTerminationPages()}
      {this.createHighResistancePages()}
      {this.createAnotOkPages()}
      {this.createBnotOkPages()}
      {this.createLongCablePages()}
      {this.createNoisePages()}
      {this.createReflectionPages()}
      {/* Disclaimer */}
      {this.createDisclaimerPage()}
    </Document>;
    return doc;
  }

  createIntroPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "28vh" }} />

        <View style={reusableStyles.mainTitleUpperLine} />

        <Text style={reusableStyles.mainTitle}>
          {"TS Expert:"}
        </Text>

        <Text style={reusableStyles.mainTitle2}>
          {"Lista de ações"}
        </Text>

        <View style={reusableStyles.mainTitleBottomLine} />

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Data Information ------------------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.MONITORING_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.TAG_NAME_DP}{this.props.tag} </Text>
        <Text style={reusableStyles.normalText}>{Strings.SEGMENT_TAG}{this.props.scopeTag} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_VERSION_DP}{Constants.TS_MONITOR_VERSION} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_INIT_DP}{UtilsInstance.getMonitorInitTime(this.props.uptime, UtilsInstance)} </Text>
        <Text style={reusableStyles.normalText}>{Strings.GENERATING_TIME_DP}{this.getDateTimeNow()} </Text>
        <Text style={reusableStyles.lastInfoText}>{Strings.DURATION_SINCE_MON_BEGIN}{UtilsInstance.formatToRelativeTime2(this.props.uptime, UtilsInstance, Strings)} </Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.ETHERNET_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.configData.addr} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.configData.netmask} </Text>
        <Text style={reusableStyles.lastInfoText}>{Strings.GATEWAY_DP}{this.props.configData.gateway} </Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.WLAN_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME_DP}{this.props.wifiConfigData.wifiName}</Text>
        <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.wifiConfigData.wifiAddr}</Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.wifiConfigData.wifiNetmask}</Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.wifiConfigData.wifiGateway}</Text>

        {this.getPageFooter()}

      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        {/* Protocol */}
        {this.getSummaryItem(Constants.RETRIES_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DIAGNOSTIC_ERROR_TYPE)}
        {this.getSummaryItem(Constants.FAULT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.FAULT_SEQUENCE_ERROR_TYPE)}
        {this.getSummaryItem(Constants.CONFIG_ERROR_TYPE)}
        {this.getSummaryItem(Constants.PARAM_ERROR_TYPE)}
        {this.getSummaryItem(Constants.MISSING_ERROR_TYPE)}
        {this.getSummaryItem(Constants.ONLINE_ERROR_TYPE)}
        {this.getSummaryItem(Constants.CRITICAL_SLAVE_ERROR_TYPE)}
        {this.getSummaryItem(Constants.MASTER_FAULT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE)}
        {/* Scope DP */}
        {this.getSummaryItem(Constants.TERMINATION_OFF_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.NO_POWER_SUPPLY_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.HIGH_RESISTANCE_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.A_NOT_OK_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.B_NOT_OK_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.LONG_CABLE_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.NOISE_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.REFLECTION_PROBLEM_TYPE)}
        {/* Disclaimer */}
        {this.getSummaryItem("disclaimer")}

        {this.getPageFooter()}

      </Page>
    );
  }

  getSummaryItem = (type) => {
    // Protocol
    if (type === Constants.RETRIES_ERROR_TYPE && this.props.retry.length > 0) {
      currentSummaryIndex++;
      retryPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {retryPageIndex}. {Strings.DEVICE_WITH_RETRIES} {Strings.DEVICE_WITH_RETRIES_DOTS} {this.state.firstRetryPage}
        </Text>
      );
    }
    else if (type === Constants.DIAGNOSTIC_ERROR_TYPE && this.props.diagnostic.length > 0) {
      currentSummaryIndex++;
      diagnosticPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {diagnosticPageIndex}. {Strings.DEVICE_WITH_DIAGNOSTIC} {Strings.DEVICE_WITH_DIAGNOSTIC_DOTS} {this.state.firstDiagnosticPage}
        </Text>
      );
    }
    else if (type === Constants.FAULT_ERROR_TYPE && this.props.fault.length > 0) {
      currentSummaryIndex++;
      faultPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {faultPageIndex}. {Strings.DEVICE_WITH_FAULT} {Strings.DEVICE_WITH_FAULT_DOTS} {this.state.firstFaultPage}
        </Text>
      );
    }
    else if (type === Constants.CONFIG_ERROR_TYPE && this.props.errorConfig.length > 0) {
      currentSummaryIndex++;
      errorConfigPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {errorConfigPageIndex}. {Strings.DEVICE_WITH_CONFIG_ERROR} {Strings.DEVICE_WITH_CONFIG_ERROR_DOTS} {this.state.firstErrorConfigPage}
        </Text>
      );
    }
    else if (type === Constants.PARAM_ERROR_TYPE && this.props.errorParam.length > 0) {
      currentSummaryIndex++;
      errorParamPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {errorParamPageIndex}. {Strings.DEVICE_WITH_PARAM_ERROR} {Strings.DEVICE_WITH_PARAM_ERROR_DOTS} {this.state.firstErrorParamPage}
        </Text>
      );
    }
    else if (type === Constants.MISSING_ERROR_TYPE && this.props.missing.length > 0) {
      currentSummaryIndex++;
      missingPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {missingPageIndex}. {Strings.DEVICE_MISSING} {Strings.DEVICE_MISSING_DOTS} {this.state.firstMissingPage}
        </Text>
      );
    }
    else if (type === Constants.ONLINE_ERROR_TYPE && this.props.online.length > 0) {
      currentSummaryIndex++;
      onlinePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {onlinePageIndex}. {Strings.DEVICE_ONLINE} {Strings.DEVICE_ONLINE_DOTS} {this.state.firstOnlinePage}
        </Text>
      );
    }
    else if (type === Constants.CRITICAL_SLAVE_ERROR_TYPE && this.props.automaticBlacklist.length > 0) {
      currentSummaryIndex++;
      automaticBlacklistPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {automaticBlacklistPageIndex}. {Strings.DEVICE_IS_CRITICAL_SLAVE} {Strings.DEVICE_IS_CRITICAL_SLAVE_DOTS} {this.state.firstAutomaticBlacklistPage}
        </Text>
      );
    }
    else if (type === Constants.MASTER_FAULT_ERROR_TYPE && this.props.masterFault.length > 0) {
      currentSummaryIndex++;
      masterFaultPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {masterFaultPageIndex}. {Strings.DEVICE_IS_MASTER_FAULT} {Strings.DEVICE_IS_MASTER_FAULT_DOTS} {this.state.firstMasterFaultPage}
        </Text>
      );
    }
    else if (type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE && this.props.fiberLowerLimitMaintenanceRequired.length > 0) {
      currentSummaryIndex++;
      fiberLowerLimitMaintenanceRequiredPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {fiberLowerLimitMaintenanceRequiredPageIndex}. {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER} {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS} {this.state.firstFiberLowerLimitMaintenanceRequiredPage}
        </Text>
      );
    }
    else if (type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE && this.props.fiberLowerLimitUrgentMaintenance.length > 0) {
      currentSummaryIndex++;
      fiberLowerLimitUrgentMaintenancePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {fiberLowerLimitUrgentMaintenancePageIndex}. {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER} {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS} {this.state.firstFiberLowerLimitUrgentMaintenancePage}
        </Text>
      );
    }
    else if (type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE && this.props.fiberSignalLost.length > 0) {
      currentSummaryIndex++;
      fiberSignalLostPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {fiberSignalLostPageIndex}. {Strings.FIBER_SIGNAL_LOSS_LIST_HEADER} {Strings.FIBER_SIGNAL_LOSS_DOTS} {this.state.firstFiberSignalLostPage}
        </Text>
      );
    }
    // Scope DP
    else if (type === Constants.TERMINATION_OFF_PROBLEM_TYPE && this.props.terminationOFF.length > 0) {
      currentSummaryIndex++;
      terminationOFFPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {terminationOFFPageIndex}. {Strings.TERMINATION_OFF_LIST_HEADER} {Strings.TERMINATION_OFF_DOTS} {this.state.firstTerminationOFFPage}
        </Text>
      );
    }
    else if (type === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE && this.props.noPowerSupplyTermination.length > 0) {
      currentSummaryIndex++;
      noPowerSupplyTerminationPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {noPowerSupplyTerminationPageIndex}. {Strings.NO_POWER_SUPPLY_LIST_HEADER} {Strings.NO_POWER_SUPPLY_DOTS} {this.state.firstNoPowerSupplyTerminationPage}
        </Text>
      );
    }
    else if (type === Constants.HIGH_RESISTANCE_PROBLEM_TYPE && this.props.highResistance.length > 0) {
      currentSummaryIndex++;
      highResistancePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {highResistancePageIndex}. {Strings.HIGH_RESISTANCE_LIST_HEADER} {Strings.HIGH_RESISTANCE_DOTS} {this.state.firstHighResistancePage}
        </Text>
      );
    }
    else if (type === Constants.A_NOT_OK_PROBLEM_TYPE && this.props.aNotOk.length > 0) {
      currentSummaryIndex++;
      aNotOkPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {aNotOkPageIndex}. {Strings.A_NOT_OK_LIST_HEADER} {Strings.A_NOT_OK_DOTS} {this.state.firstANotOkPage}
        </Text>
      );
    }
    else if (type === Constants.B_NOT_OK_PROBLEM_TYPE && this.props.bNotOk.length > 0) {
      currentSummaryIndex++;
      bNotOkPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {bNotOkPageIndex}. {Strings.B_NOT_OK_LIST_HEADER} {Strings.B_NOT_OK_DOTS} {this.state.firstBNotOkPage}
        </Text>
      );
    }
    else if (type === Constants.LONG_CABLE_PROBLEM_TYPE && this.props.longCable.length > 0) {
      currentSummaryIndex++;
      longCablePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {longCablePageIndex}. {Strings.LONG_CABLE_LIST_HEADER} {Strings.LONG_CABLE_DOTS} {this.state.firstLongCablePage}
        </Text>
      );
    }
    else if (type === Constants.NOISE_PROBLEM_TYPE && this.props.noise.length > 0) {
      currentSummaryIndex++;
      noisePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {noisePageIndex}. {Strings.NOISE_LIST_HEADER} {Strings.NOISE_DOTS} {this.state.firstNoisePage}
        </Text>
      );
    }
    else if (type === Constants.REFLECTION_PROBLEM_TYPE && this.props.reflection.length > 0) {
      currentSummaryIndex++;
      reflectionPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {reflectionPageIndex}. {Strings.REFLECTION_LIST_HEADER} {Strings.REFLECTION_DOTS} {this.state.firstReflectionPage}
        </Text>
      );
    }
    // Disclaimer
    else if (type === "disclaimer") {
      currentSummaryIndex++;
      disclaimerPageIndex = currentSummaryIndex;
      if (disclaimerPageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_EXPERT_DOTS_1} ${totalPages}`
          )} fixed />
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_EXPERT_DOTS_2} ${totalPages}`
          )} fixed />
        );
      }

    }
  }

  resetSummaryIndexes = () => {
    currentSummaryIndex = 0;
    // Protocol
    retryPageIndex = 0;
    diagnosticPageIndex = 0;
    faultPageIndex = 0;
    errorConfigPageIndex = 0;
    errorParamPageIndex = 0;
    missingPageIndex = 0;
    onlinePageIndex = 0;
    automaticBlacklistPageIndex = 0;
    masterFaultPageIndex = 0;
    // Scope DP
    terminationOFFPageIndex = 0;
    noPowerSupplyTerminationPageIndex = 0;
    highResistancePageIndex = 0;
    aNotOkPageIndex = 0;
    bNotOkPageIndex = 0;
    longCablePageIndex = 0;
    noisePageIndex = 0;
    reflectionPageIndex = 0;
    // Disclaimer
    disclaimerPageIndex = 0;
  }

  // ----------------- RETRIES -----------------
  createRetriesPages = () => {
    if (this.props.retry.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={retryStyles.page}>

          {this.getPageHeader()}

          <Text style={retryStyles.pageTitle} fixed>{retryPageIndex}. - {Strings.DEVICE_WITH_RETRIES}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.RETRIES_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.RETRIES_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.RETRIES_SUGGESTION_4}</Text>
          <Text style={reusableStyles.doubleTabbedText}>i. {Strings.RETRIES_SUGGESTION_5}</Text>
          <Text style={reusableStyles.doubleTabbedText}>ii. {Strings.RETRIES_SUGGESTION_6}</Text>
          <Text style={reusableStyles.doubleTabbedText}>iii. {Strings.RETRIES_SUGGESTION_7}</Text>
          <Text style={reusableStyles.doubleTabbedText}>iv. {Strings.RETRIES_SUGGESTION_8}</Text>
          <Text style={reusableStyles.doubleTabbedText}>v. {Strings.RETRIES_SUGGESTION_9}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.RETRIES_SUGGESTION_10}</Text>
          <Text style={reusableStyles.tabbedText}>c. {Strings.RETRIES_SUGGESTION_11}</Text>
          <Text style={reusableStyles.tabbedText}>d. {Strings.RETRIES_SUGGESTION_12}</Text>
          <Text style={reusableStyles.tabbedText}>e. {Strings.RETRIES_SUGGESTION_13}</Text>
          <Text style={reusableStyles.lastInfoText2}>
            <Text style={reusableStyles.boldText}>{Strings.SEARCH_POPUP_6_1} </Text>
            {Strings.RETRIES_SUGGESTION_14}
          </Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={retryStyles.table}>
            {this.createRetriesTableHeader()}
            {this.createRetriesTable()}
          </View>

          {this.getPageFooter("retry")}

        </Page>
      );
    }
  }

  createRetriesTableHeader = () => {
    return (
      <View style={retryStyles.tableRow} fixed>

        <View style={retryStyles.horaryTableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={retryStyles.tableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={retryStyles.tableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.RETRIES_STRING}</Text>
        </View>

        <View style={retryStyles.tableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createRetriesTable = () => {
    return (
      this.props.retry.map(problem => {
        return (
          <View style={retryStyles.tableRow} key={problem._id} wrap={false}>

            <View style={retryStyles.horaryTableCol}>
              <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={retryStyles.tableCol}>
              <Text style={retryStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={retryStyles.tableCol}>
              <Text style={retryStyles.tableCell}>{problem.total}</Text>
            </View>

            <View style={retryStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- DIAGNOSTICS -----------------
  createDiagnosticsPages = () => {
    if (this.props.diagnostic.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={diagnosticStyles.page}>

          {this.getPageHeader()}

          <Text style={diagnosticStyles.pageTitle} fixed>{diagnosticPageIndex}. - {Strings.DEVICE_WITH_DIAGNOSTIC}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DIAGNOSTIC_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DIAGNOSTIC_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.DIAGNOSTIC_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.DIAGNOSTIC_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={diagnosticStyles.table}>
            {this.createDiagnosticsTableHeader()}
            {this.createDiagnosticsTable()}
          </View>

          {this.getPageFooter("diagnostic")}

        </Page>
      );
    }
  }

  createDiagnosticsTableHeader = () => {
    return (
      <View style={diagnosticStyles.tableRow} fixed>

        <View style={diagnosticStyles.horaryTableColHeader}>
          <Text style={diagnosticStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={diagnosticStyles.tableColHeader}>
          <Text style={diagnosticStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={diagnosticStyles.tableColHeader}>
          <Text style={diagnosticStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDiagnosticsTable = () => {
    return (
      this.props.diagnostic.map(problem => {
        return (
          <View style={diagnosticStyles.tableRow} key={problem._id} wrap={false}>

            <View style={diagnosticStyles.horaryTableCol}>
              <Text style={diagnosticStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={diagnosticStyles.tableCol}>
              <Text style={diagnosticStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={diagnosticStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- FAULTS -----------------
  createFaultsPages = () => {
    if (this.props.fault.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={faultStyles.page}>

          {this.getPageHeader()}

          <Text style={faultStyles.pageTitle} fixed>{faultPageIndex}. - {Strings.DEVICE_WITH_FAULT}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.FAULT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.FAULT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.FAULT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.FAULT_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>c. {Strings.FAULT_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>d. {Strings.FAULT_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={faultStyles.table}>
            {this.createFaultsTableHeader()}
            {this.createFaultsTable()}
          </View>

          {this.getPageFooter("fault")}

        </Page>
      );
    }
  }

  createFaultsTableHeader = () => {
    return (
      <View style={faultStyles.tableRow} fixed>

        <View style={faultStyles.horaryTableColHeader}>
          <Text style={faultStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={faultStyles.tableColHeader}>
          <Text style={faultStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={faultStyles.tableColHeader}>
          <Text style={faultStyles.tableCellHeader}>{Strings.FAULTS_STRING}</Text>
        </View>

        <View style={faultStyles.tableColHeader}>
          <Text style={faultStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createFaultsTable = () => {
    return (
      this.props.fault.map(problem => {
        return (
          <View style={faultStyles.tableRow} key={problem._id} wrap={false}>

            <View style={faultStyles.horaryTableCol}>
              <Text style={faultStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={faultStyles.tableCol}>
              <Text style={faultStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={faultStyles.tableCol}>
              <Text style={faultStyles.tableCell}>{problem.total}</Text>
            </View>

            <View style={faultStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- CONFIG ERROR -----------------
  createConfigErrorPages = () => {
    if (this.props.errorConfig.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={configErrorStyles.page}>

          {this.getPageHeader()}

          <Text style={configErrorStyles.pageTitle} fixed>{errorConfigPageIndex}. - {Strings.DEVICE_WITH_CONFIG_ERROR}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.CONFIG_ERROR_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.CONFIG_ERROR_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.CONFIG_ERROR_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={configErrorStyles.table}>
            {this.createConfigErrorTableHeader()}
            {this.createConfigErrorTable()}
          </View>

          {this.getPageFooter("errorConfig")}

        </Page>
      );
    }
  }

  createConfigErrorTableHeader = () => {
    return (
      <View style={configErrorStyles.tableRow} fixed>

        <View style={configErrorStyles.horaryTableColHeader}>
          <Text style={configErrorStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={configErrorStyles.tableColHeader}>
          <Text style={configErrorStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={configErrorStyles.tableColHeader}>
          <Text style={configErrorStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createConfigErrorTable = () => {
    return (
      this.props.errorConfig.map(problem => {
        return (
          <View style={configErrorStyles.tableRow} key={problem._id} wrap={false}>

            <View style={configErrorStyles.horaryTableCol}>
              <Text style={configErrorStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={configErrorStyles.tableCol}>
              <Text style={configErrorStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={configErrorStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- PARAM ERROR -----------------
  createParamErrorPages = () => {
    if (this.props.errorParam.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={paramErrorStyles.page}>

          {this.getPageHeader()}

          <Text style={paramErrorStyles.pageTitle} fixed>{errorParamPageIndex}. - {Strings.DEVICE_WITH_PARAM_ERROR}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.PARAM_ERROR_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.PARAM_ERROR_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.PARAM_ERROR_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={paramErrorStyles.table}>
            {this.createParamErrorTableHeader()}
            {this.createParamErrorTable()}
          </View>

          {this.getPageFooter("errorParam")}

        </Page>
      );
    }
  }

  createParamErrorTableHeader = () => {
    return (
      <View style={paramErrorStyles.tableRow} fixed>

        <View style={paramErrorStyles.horaryTableColHeader}>
          <Text style={paramErrorStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={paramErrorStyles.tableColHeader}>
          <Text style={paramErrorStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={paramErrorStyles.tableColHeader}>
          <Text style={paramErrorStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createParamErrorTable = () => {
    return (
      this.props.errorParam.map(problem => {
        return (
          <View style={paramErrorStyles.tableRow} key={problem._id} wrap={false}>

            <View style={paramErrorStyles.horaryTableCol}>
              <Text style={paramErrorStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={paramErrorStyles.tableCol}>
              <Text style={paramErrorStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={paramErrorStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- MISSING -----------------
  createMissingPages = () => {
    if (this.props.missing.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={missingStyles.page}>

          {this.getPageHeader()}

          <Text style={missingStyles.pageTitle} fixed>{missingPageIndex}. - {Strings.DEVICE_MISSING}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MISSING_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.MISSING_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.MISSING_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.MISSING_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={missingStyles.table}>
            {this.createMissingTableHeader()}
            {this.createMissingTable()}
          </View>

          {this.getPageFooter("missing")}

        </Page>
      );
    }
  }

  createMissingTableHeader = () => {
    return (
      <View style={missingStyles.tableRow} fixed>

        <View style={missingStyles.horaryTableColHeader}>
          <Text style={missingStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={missingStyles.tableColHeader}>
          <Text style={missingStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={missingStyles.tableColHeader}>
          <Text style={missingStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createMissingTable = () => {
    return (
      this.props.missing.map(problem => {
        return (
          <View style={missingStyles.tableRow} key={problem._id} wrap={false}>

            <View style={missingStyles.horaryTableCol}>
              <Text style={missingStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={missingStyles.tableCol}>
              <Text style={missingStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={missingStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- ONLINE -----------------
  createOnlinePages = () => {
    if (this.props.online.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={onlineStyles.page}>

          {this.getPageHeader()}

          <Text style={onlineStyles.pageTitle} fixed>{onlinePageIndex}. - {Strings.DEVICE_ONLINE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.ONLINE_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.ONLINE_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.ONLINE_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={onlineStyles.table}>
            {this.createOnlineTableHeader()}
            {this.createOnlineTable()}
          </View>

          {this.getPageFooter("online")}

        </Page>
      );
    }
  }

  createOnlineTableHeader = () => {
    return (
      <View style={onlineStyles.tableRow} fixed>

        <View style={onlineStyles.horaryTableColHeader}>
          <Text style={onlineStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={onlineStyles.tableColHeader}>
          <Text style={onlineStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={onlineStyles.tableColHeader}>
          <Text style={onlineStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createOnlineTable = () => {
    return (
      this.props.online.map(problem => {
        return (
          <View style={onlineStyles.tableRow} key={problem._id} wrap={false}>

            <View style={onlineStyles.horaryTableCol}>
              <Text style={onlineStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={onlineStyles.tableCol}>
              <Text style={onlineStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={onlineStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- CRITICAL SLAVE -----------------
  createCriticalSlavePages = () => {
    if (this.props.automaticBlacklist.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={criticalSlaveStyles.page}>

          {this.getPageHeader()}

          <Text style={criticalSlaveStyles.pageTitle} fixed>{automaticBlacklistPageIndex}. - {Strings.DEVICE_IS_CRITICAL_SLAVE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.CRITICAL_SLAVE_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.CRITICAL_SLAVE_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.CRITICAL_SLAVE_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.CRITICAL_SLAVE_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>c. {Strings.CRITICAL_SLAVE_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>d. {Strings.CRITICAL_SLAVE_SUGGESTION_6}</Text>
          <Text style={reusableStyles.tabbedText}>e. {Strings.CRITICAL_SLAVE_SUGGESTION_7}</Text>
          <Text style={reusableStyles.tabbedText}>f. {Strings.CRITICAL_SLAVE_SUGGESTION_8}</Text>
          <Text style={reusableStyles.tabbedText}>g. {Strings.CRITICAL_SLAVE_SUGGESTION_9}</Text>
          <Text style={reusableStyles.tabbedText}>h. {Strings.CRITICAL_SLAVE_SUGGESTION_10}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={criticalSlaveStyles.table}>
            {this.createCriticalSlaveTableHeader()}
            {this.createCriticalSlaveTable()}
          </View>

          {this.getPageFooter("automaticBlacklist")}

        </Page>
      );
    }
  }

  createCriticalSlaveTableHeader = () => {
    return (
      <View style={criticalSlaveStyles.tableRow} fixed>

        <View style={criticalSlaveStyles.horaryTableColHeader}>
          <Text style={criticalSlaveStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={criticalSlaveStyles.tableColHeader}>
          <Text style={criticalSlaveStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={criticalSlaveStyles.tableColHeader}>
          <Text style={criticalSlaveStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createCriticalSlaveTable = () => {
    return (
      this.props.automaticBlacklist.map(problem => {
        return (
          <View style={criticalSlaveStyles.tableRow} key={problem._id} wrap={false}>

            <View style={criticalSlaveStyles.horaryTableCol}>
              <Text style={criticalSlaveStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={criticalSlaveStyles.tableCol}>
              <Text style={criticalSlaveStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={criticalSlaveStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- MASTER FAULT -----------------
  createMasterFaultPages = () => {
    if (this.props.masterFault.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={masterFaultStyles.page}>

          {this.getPageHeader()}

          <Text style={masterFaultStyles.pageTitle} fixed>{masterFaultPageIndex}. - {Strings.DEVICE_IS_MASTER_FAULT}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MASTER_FAULT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.MASTER_FAULT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.MASTER_FAULT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.MASTER_FAULT_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>c. {Strings.MASTER_FAULT_SUGGESTION_5}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={masterFaultStyles.table}>
            {this.createMasterFautTableHeader()}
            {this.createMasterFautTable()}
          </View>

          {this.getPageFooter("masterFault")}

        </Page>
      );
    }
  }

  createMasterFautTableHeader = () => {
    return (
      <View style={masterFaultStyles.tableRow} fixed>

        <View style={masterFaultStyles.horaryTableColHeader}>
          <Text style={masterFaultStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={masterFaultStyles.tableColHeader}>
          <Text style={masterFaultStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={masterFaultStyles.tableColHeader}>
          <Text style={masterFaultStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createMasterFautTable = () => {
    return (
      this.props.masterFault.map(problem => {
        return (
          <View style={masterFaultStyles.tableRow} key={problem._id} wrap={false}>

            <View style={masterFaultStyles.horaryTableCol}>
              <Text style={masterFaultStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={masterFaultStyles.tableCol}>
              <Text style={masterFaultStyles.tableCell}>{problem.address}</Text>
            </View>

            <View style={masterFaultStyles.solvedTableCol}>
              <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- FIBER LOWER LIMIT URGENT MAINTENANCE -----------------
  createFiberLowerLimitUrgentMaintenancePages = () => {
    if (this.props.fiberLowerLimitUrgentMaintenance.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{fiberLowerLimitUrgentMaintenancePageIndex}{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          <View style={fiberLowerLimitUrgentMaintenanceStyles.table}>
            {this.createFiberLowerLimitUrgentMaintenanceTableHeader()}
            {this.createFiberLowerLimitUrgentMaintenanceTable()}
          </View>

          {this.getPageFooter("fiberLowerLimitUrgentMaintenance")}

        </Page>
      );
    }
  }

  createFiberLowerLimitUrgentMaintenanceTableHeader = () => {
    return (
      <View style={fiberLowerLimitUrgentMaintenanceStyles.tableRow} fixed>

        <View style={fiberLowerLimitUrgentMaintenanceStyles.channelTableColHeader}>
          <Text style={fiberLowerLimitUrgentMaintenanceStyles.tableCellHeader}>{Strings.CHANNEL}</Text>
        </View>

        <View style={fiberLowerLimitUrgentMaintenanceStyles.voltageTableColHeader}>
          <Text style={fiberLowerLimitUrgentMaintenanceStyles.tableCellHeader}>{Strings.VOLTAGE_}</Text>
        </View>
      </View>
    );
  }

  createFiberLowerLimitUrgentMaintenanceTable = () => {
    return this.props.fiberLowerLimitUrgentMaintenance.map(data => {
      console.log(data);
      let voltage = data.voltage !== null ? parseFloat(data.voltage).toFixed(2) : Strings.UNKNOWN;

      return (
        <View style={fiberLowerLimitUrgentMaintenanceStyles.tableRow} key={data._id} wrap={false}>

          <View style={fiberLowerLimitUrgentMaintenanceStyles.channelTableCol}>
            <Text style={fiberLowerLimitUrgentMaintenanceStyles.tableCell}>{data.channel}</Text>
          </View>

          <View style={fiberLowerLimitUrgentMaintenanceStyles.voltageTableCol}>
            <Text style={fiberLowerLimitUrgentMaintenanceStyles.tableCell}>{voltage} V</Text>
          </View>
        </View>
      );
    });
  }

  // ----------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED -----------------
  createFiberLowerLimitMaintenanceRequiredPages = () => {
    if (this.props.fiberLowerLimitMaintenanceRequired.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{fiberLowerLimitMaintenanceRequiredPageIndex}{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          <View style={fiberLowerLimitMaintenanceRequiredStyles.table}>
            {this.createFiberLowerLimitMaintenanceRequiredTableHeader()}
            {this.createFiberLowerLimitMaintenanceRequiredTable()}
          </View>

          {this.getPageFooter("fiberLowerLimitMaintenanceRequired")}

        </Page>
      );
    }
  }

  createFiberLowerLimitMaintenanceRequiredTableHeader = () => {
    return (
      <View style={fiberLowerLimitMaintenanceRequiredStyles.tableRow} fixed>

        <View style={fiberLowerLimitMaintenanceRequiredStyles.channelTableColHeader}>
          <Text style={fiberLowerLimitMaintenanceRequiredStyles.tableCellHeader}>{Strings.CHANNEL}</Text>
        </View>

        <View style={fiberLowerLimitMaintenanceRequiredStyles.voltageTableColHeader}>
          <Text style={fiberLowerLimitMaintenanceRequiredStyles.tableCellHeader}>{Strings.VOLTAGE_}</Text>
        </View>
      </View>
    );
  }

  createFiberLowerLimitMaintenanceRequiredTable = () => {
    return this.props.fiberLowerLimitMaintenanceRequired.map(data => {
      console.log(data);
      let voltage = data.voltage !== null ? parseFloat(data.voltage).toFixed(2) : Strings.UNKNOWN;

      return (
        <View style={fiberLowerLimitMaintenanceRequiredStyles.tableRow} key={data._id} wrap={false}>

          <View style={fiberLowerLimitMaintenanceRequiredStyles.channelTableCol}>
            <Text style={fiberLowerLimitMaintenanceRequiredStyles.tableCell}>{data.channel}</Text>
          </View>

          <View style={fiberLowerLimitMaintenanceRequiredStyles.voltageTableCol}>
            <Text style={fiberLowerLimitMaintenanceRequiredStyles.tableCell}>{voltage} V</Text>
          </View>
        </View>
      );
    });
  }

  // ----------------- FIBER SIGNAL LOSS -----------------
  createFiberSignalLostPages = () => {
    if (this.props.fiberSignalLost.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{fiberSignalLostPageIndex}{Strings.FIBER_SIGNAL_LOSS_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_SIGNAL_LOSS_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_SIGNAL_LOSS_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.FIBER_SIGNAL_LOSS_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createFiberSignalLostTable()}
          {this.getPageFooter("fiberSignalLost")}

        </Page>
      );
    }
  }

  createFiberSignalLostTable = () => {
    return (
      this.props.fiberSignalLost.map(data => {
        return (
          <View key={data._id} >
            <Text style={reusableStyles.normalSpacedText}>
              <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>{this.formatTime(data)}
            </Text>
            <Text style={reusableStyles.lastInfoText}>
              <Text style={reusableStyles.boldText}>{Strings.RELAY_STATUS}: </Text>{Strings.FAULT}
            </Text>
          </View>
        );
      })
    );
  }

  // ----------------- TERMINATION OFF -----------------
  createTerminationOFFPages = () => {
    if (this.props.terminationOFF.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{terminationOFFPageIndex}{Strings.TERMINATION_OFF_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText2}>
            {Strings.TERMINATION_OFF_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.TERMINATION_OFF_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.TERMINATION_OFF_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.TERMINATION_OFF_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.TERMINATION_OFF_SUGGESTION_5}</Text>

          <Text style={reusableStyles.lastInfoText}>{Strings.TERMINATION_OFF_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createTerminationOFFImages()}
          {this.getPageFooter("terminationOFF")}

        </Page>
      );
    }
  }

  createTerminationOFFImages = () => {
    return (
      this.props.terminationOFFImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveBA.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- NO POWER SUPPLY TERMINATION -----------------
  createNoPowerSupplyTerminationPages = () => {
    if (this.props.noPowerSupplyTermination.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{noPowerSupplyTerminationPageIndex}{Strings.NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.NO_POWER_SUPPLY_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.NO_POWER_SUPPLY_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>{"• Pin 5 => GND"}</Text>
          <Text style={reusableStyles.tabbedText}>{"• Pin 6 => + 5Vdc"}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.NO_POWER_SUPPLY_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.NO_POWER_SUPPLY_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createNoPowerSupplyImages()}
          {this.getPageFooter("noPowerSupplyTermination")}

        </Page>
      );
    }
  }

  createNoPowerSupplyImages = () => {
    return (
      this.props.noPowerSupplyTerminationImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveBA.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- HIGH RESISTANCE -----------------
  createHighResistancePages = () => {
    if (this.props.highResistance.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{highResistancePageIndex}{Strings.HIGH_RESISTANCE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.HIGH_RESISTANCE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.HIGH_RESISTANCE_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.HIGH_RESISTANCE_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.HIGH_RESISTANCE_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.HIGH_RESISTANCE_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.HIGH_RESISTANCE_SUGGESTION_6}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.HIGH_RESISTANCE_SUGGESTION_7}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.HIGH_RESISTANCE_SUGGESTION_8}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createHighResistanceImages()}
          {this.getPageFooter("highResistance")}

        </Page>
      );
    }
  }

  createHighResistanceImages = () => {
    return (
      this.props.highResistanceImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveBA.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- A NOT OK -----------------
  createAnotOkPages = () => {
    if (this.props.aNotOk.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{aNotOkPageIndex}{Strings.A_NOT_OK_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.A_NOT_OK_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.A_NOT_OK_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.A_NOT_OK_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.A_NOT_OK_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createAnotOkImages()}
          {this.getPageFooter("aNotOk")}

        </Page>
      );
    }
  }

  createAnotOkImages = () => {
    return (
      this.props.aNotOkImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveAB.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- B NOT OK -----------------
  createBnotOkPages = () => {
    if (this.props.bNotOk.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{bNotOkPageIndex}{Strings.B_NOT_OK_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.B_NOT_OK_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.B_NOT_OK_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.B_NOT_OK_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.B_NOT_OK_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createBnotOkImages()}
          {this.getPageFooter("bNotOk")}

        </Page>
      );
    }
  }

  createBnotOkImages = () => {
    return (
      this.props.bNotOkImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveAB.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- LONG CABLE -----------------
  createLongCablePages = () => {
    if (this.props.longCable.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{longCablePageIndex}{Strings.LONG_CABLE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.LONG_CABLE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.LONG_CABLE_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.LONG_CABLE_SUGGESTION_3}</Text>
          {this.getBaudRateTable()}

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createLongCableImages()}
          {this.getPageFooter("longCable")}

        </Page>
      );
    }
  }

  createLongCableImages = () => {
    return (
      this.props.longCableImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveBA.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  getBaudRateTable = () => {
    return (
      <View style={{ marginBottom: "1vh" }}>
        <View style={baudRateStyles.tableRow}>

          <View style={baudRateStyles.baudRateTableColHeader}>
            <Text style={baudRateStyles.tableCellHeader}>Baud rate</Text>
          </View>

          <View style={baudRateStyles.cableLengthTableColHeader}>
            <Text style={baudRateStyles.tableCellHeader}>Comprimento</Text>
          </View>

        </View>

        {
          baudRateValues.map(info => {
            const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

            return (
              <View style={baudRateStyles.tableRow} key={info.baudRate} wrap={false}>

                <View style={baudRateStyles.baudRateTableCol}>
                  <Text style={baudRateStyles.tableCell}>
                    {(lang !== Constants.EN_LANG_KEY) ? UtilsInstance.replacePointWithComma(info.baudRate) : info.baudRate}
                  </Text>
                </View>

                <View style={baudRateStyles.cableLengthTableCol}>
                  <Text style={baudRateStyles.tableCell}>{info.cableLength}</Text>
                </View>

              </View>
            );

          })
        }
      </View>
    );
  }

  // ----------------- NOISE -----------------
  createNoisePages = () => {
    if (this.props.noise.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{noisePageIndex}{Strings.NOISE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.NOISE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.NOISE_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_4}</Text>
          {this.getNoiseTable()}
          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_5}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.NOISE_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createNoiseImages()}
          {this.getPageFooter("noise")}

        </Page>
      );
    }
  }

  getNoiseTable = () => {
    return (
      <View style={{ marginBottom: "1vh" }}>
        <View style={baudRateStyles.tableRow}>

          <View style={baudRateStyles.baudRateTableColHeader}>
            <Text style={baudRateStyles.tableCellHeader}>{Strings.NOISE_SUGGESTION_TABLE_HEADER_1}</Text>
          </View>

          <View style={baudRateStyles.cableLengthTableColHeader}>
            <Text style={baudRateStyles.tableCellHeader}>{Strings.NOISE_SUGGESTION_TABLE_HEADER_2}</Text>
          </View>

        </View>

        <View style={baudRateStyles.tableRow} wrap={false}>

          <View style={baudRateStyles.baudRateTableCol}>
            <Text style={baudRateStyles.tableCell}>&lt; {Strings.NOISE_SUGGESTION_TABLE_11}</Text>
          </View>

          <View style={baudRateStyles.cableLengthTableCol}>
            <Text style={baudRateStyles.tableCell}>{Strings.NOISE_SUGGESTION_TABLE_12}</Text>
          </View>

        </View>

        <View style={baudRateStyles.tableRow} wrap={false}>

          <View style={baudRateStyles.baudRateTableCol}>
            <Text style={baudRateStyles.tableCell}>&lt; {Strings.NOISE_SUGGESTION_TABLE_21}</Text>
          </View>

          <View style={baudRateStyles.cableLengthTableCol}>
            <Text style={baudRateStyles.tableCell}>{Strings.NOISE_SUGGESTION_TABLE_22}</Text>
          </View>

        </View>

        <View style={baudRateStyles.tableRow} wrap={false}>

          <View style={baudRateStyles.baudRateTableCol}>
            <Text style={baudRateStyles.tableCell}>&lt; {Strings.NOISE_SUGGESTION_TABLE_31}</Text>
          </View>

          <View style={baudRateStyles.cableLengthTableCol}>
            <Text style={baudRateStyles.tableCell}>
              {Strings.NOISE_SUGGESTION_TABLE_321}
              <Text style={baudRateStyles.boldTableCell}>{Strings.NOISE_SUGGESTION_TABLE_322}</Text>
              {Strings.NOISE_SUGGESTION_TABLE_323}
            </Text>
          </View>

        </View>

        <View style={baudRateStyles.tableRow} wrap={false}>

          <View style={baudRateStyles.baudRateTableCol}>
            <Text style={baudRateStyles.tableCell}>&gt; {Strings.NOISE_SUGGESTION_TABLE_41}</Text>
          </View>

          <View style={baudRateStyles.cableLengthTableCol}>
            <Text style={baudRateStyles.tableCell}>
              <Text style={baudRateStyles.boldTableCell}>{Strings.NECESSARY_ACTION}</Text>
              {Strings.NOISE_SUGGESTION_TABLE_42}
            </Text>
          </View>

        </View>

      </View>
    );
  }

  createNoiseImages = () => {
    return (
      this.props.noiseImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveAB.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- REFLECTION -----------------
  createReflectionPages = () => {
    if (this.props.reflection.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={terminationOffStyles.page}>

          {this.getPageHeader()}

          <Text style={terminationOffStyles.pageTitle} fixed>{reflectionPageIndex}{Strings.REFLECTION_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.REFLECTION_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.REFLECTION_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.REFLECTION_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.REFLECTION_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.REFLECTION_SUGGESTION_5}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.REFLECTION_SUGGESTION_6}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.REFLECTION_SUGGESTION_7}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createReflectionImages()}
          {this.getPageFooter("reflection")}

        </Page>
      );
    }
  }

  createReflectionImages = () => {
    return (
      this.props.reflectionImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.waveBA.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    this.resetSummaryIndexes();
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  leftSubHeaderText: {
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "left",
  },

  centeredSubHeaderText: {
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center",
  },

  centeredSecondSubHeaderText: {
    marginTop: "3vh",
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  smallSubHeaderLine: {
    height: "1px",
    width: "70px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "1vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginTop: "1vh",
    marginBottom: 4,
    fontFamily: "RobotoMedium"
  },

  normalSpacedText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText2: {
    fontSize: 12,
    marginBottom: "4vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  checkBox: {
    width: 12,
    height: 12,
  },

  mainTitleUpperLine: {
    marginTop: "2vh",
    marginBottom: "2vh",
    marginLeft: "180px",
    height: "1px",
    width: "156px",
    backgroundColor: "black",
  },

  mainTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle2: {
    marginTop: "1vh",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitleBottomLine: {
    marginTop: "2vh",
    marginLeft: "206px",
    height: "1px",
    width: "100px",
    backgroundColor: "black",
  },

  noErrors: {
    //marginTop: "28vh",
    textAlign: "center",
    fontSize: 12,
    //marginBottom: "4vh",
    //fontWeight: "bold",
    fontFamily: "RobotoRegular"
  },

  tabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  tabbedText2: {
    fontSize: 12,
    //marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  doubleTabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 20,
    fontFamily: "RobotoRegular"
  },

  subHeaderInnerLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "1vh"
  },
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const retryStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const diagnosticStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const faultStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const configErrorStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const paramErrorStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const missingStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const onlineStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const criticalSlaveStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const masterFaultStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const terminationOffStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 20
  },

  pageTitle: {
    fontSize: 18,
    //marginTop: "2vh",
    marginBottom: "2vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const baudRateStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  baudRateTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  cableLengthTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  boldTableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  baudRateTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  cableLengthTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
});

const oscilloscopeStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "2vh",
    height: "20vh",
    width: "60vw"
  }
});

const fiberLowerLimitUrgentMaintenanceStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 20
  },

  pageTitle: {
    fontSize: 18,
    //marginTop: "2vh",
    marginBottom: "2vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  channelTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  voltageTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  channelTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  voltageTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
});

const fiberLowerLimitMaintenanceRequiredStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 20
  },

  pageTitle: {
    fontSize: 18,
    //marginTop: "2vh",
    marginBottom: "2vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  channelTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  voltageTableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  channelTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  voltageTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
});

export default TsExpertReport;
